import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/constants";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 left-6 z-50 group"
      aria-label="Contactar por WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 blur-xl group-hover:opacity-80 transition-opacity pulse-dot" />
      <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1eb854] text-white font-semibold px-5 py-3.5 rounded-full shadow-2xl transition-transform group-hover:scale-105">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-6 h-6"
        >
          <path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4a7.95 7.95 0 0 0-6.86 11.96L4 20l4.16-1.09a7.94 7.94 0 0 0 3.89 1h.01c4.38 0 7.95-3.57 7.95-7.95a7.9 7.9 0 0 0-2.41-5.64Zm-5.55 12.23h-.01a6.6 6.6 0 0 1-3.37-.92l-.24-.14-2.47.65.66-2.4-.16-.25a6.6 6.6 0 1 1 12.24-3.52 6.6 6.6 0 0 1-6.6 6.6Zm3.62-4.94c-.2-.1-1.18-.58-1.36-.65-.18-.07-.32-.1-.45.1-.13.2-.51.65-.62.79-.12.13-.23.15-.42.05-.2-.1-.84-.31-1.6-.99-.6-.53-.99-1.18-1.11-1.38-.12-.2-.01-.31.09-.41.09-.09.2-.23.3-.35.1-.12.13-.2.2-.33.07-.13.03-.25-.01-.35-.05-.1-.45-1.08-.61-1.48-.16-.39-.33-.34-.45-.34h-.39c-.13 0-.35.05-.53.25s-.7.68-.7 1.66.71 1.93.81 2.06c.1.13 1.4 2.14 3.4 3 .47.21.85.33 1.14.42.48.15.92.13 1.26.08.39-.06 1.18-.48 1.35-.95.17-.47.17-.87.12-.95-.05-.08-.18-.13-.39-.23Z" />
        </svg>
        <span className="text-sm font-bold tracking-wide">313 722 6319</span>
      </span>
    </a>
  );
}
